import * as DevelopersService from "../../RainbowSdk/DevelopersService";
import * as ContactsActions from "../Actions/ContactsActions";
import LogService from "../../CommonSdk/LogService";

import * as ContactsActionTypes from "./ContactsActionTypes";
import * as ErrorUtils from "../../Utils/ErrorUtils";
import * as constants from "../../Constants/SdkConstant";

const LOG_TAG = "ACTIONS:DEVELOPERS";

export const getAllDevelopers = () => (dispatch) => {
    LogService.trace(LOG_TAG, "getAllDevelopers");

    return getAllDevelopersPerPage({ format: "full" })
        .then(developerList => {
            LogService.info(LOG_TAG, "getAllDevelopers", "success");
            //check for avatar
            developerList = developerList.map(developer => {
                let avatar = ContactsActions.getContactAvatar(developer);
                if (avatar)
                    developer.avatar = avatar;
                return developer;
            });

            dispatch({
                type: ContactsActionTypes.CONTACTS_UPDATE,
                payload: {
                    contacts: developerList,
                }
            });
            return Promise.resolve(developerList);
        })
        .catch(error => {
            LogService.error(LOG_TAG, "getAllDevelopers", "can't retrieve the developers", error.errorCode, error.errorMessage);

            if (error.developers) {
                dispatch({
                    type: ContactsActionTypes.CONTACTS_UPDATE,
                    payload: {
                        contacts: error.developers,
                    }
                });
            };
            return Promise.reject(ErrorUtils.parseErrorAndReturnPayload(error))
        });
};

export const getAllDevelopersPerPage = (criteria) => {
    return DevelopersService.getDevelopersPerPage(0, constants.MAX_PAGE_SIZE, criteria)
        .then(response => {
            let developerList = response.data;
            LogService.info(LOG_TAG, "getAllDevelopersPerPage", response.total);

            const promiseArray = [];
            for (let i = 1; i < response.total / constants.MAX_PAGE_SIZE; i++) { //fetch all other developers
                promiseArray.push(DevelopersService.getDevelopersPerPage(i, constants.MAX_PAGE_SIZE, criteria));
            }

            return Promise.allSettled(promiseArray)
                .then(results => {
                    const errorReasonList = [];
                    results.forEach((result, i) => {
                        if (result.status === "fulfilled") {
                            developerList.push(...result.value.data);
                        } else {
                            errorReasonList.push({ [i]: result.reason });
                        }
                    });

                    if (errorReasonList.length > 0) {
                        const errorFilteredList = developerList.filter(developer => developer);
                        return Promise.reject({
                            errorCode: 0,
                            errorMessage: ErrorUtils.parseErrorMessageArray(errorReasonList),
                            developers: errorFilteredList
                        });
                    } else {
                        return Promise.resolve(developerList);
                    }
                });
        })
        .catch(errorPayload => {
            return Promise.reject(errorPayload);
        });
};

export const createSandBoxAdminAccount = () => dispatch => {
    LogService.trace(LOG_TAG, "createSandBoxAdminAccount");

    return DevelopersService.createSandBoxAdminAccount()
        .then((data) => {
            return Promise.resolve(data);
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};

export const getSandBoxInformations = () => dispatch => {
    LogService.trace(LOG_TAG, "getSandBoxInformations");

    return DevelopersService.getSandBoxInformations()
        .then((informations) => {
            return Promise.resolve(informations);
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};